import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AuditHelperFunctions } from 'src/app/helpers/audit-helper-functions';
import { AuditMerchantParamsViewModel } from 'src/app/models/audit-merchant-params-view-model';
import { AuditService } from 'src/app/services/audit.service';

@Component({
  selector: 'app-audit-merchant-params-data-details',
  templateUrl: './audit-merchant-params-data-details.component.html',
  styleUrls: ['./audit-merchant-params-data-details.component.scss']
})
export class AuditMerchantParamsDataDetailsComponent implements OnInit {
  @Input() merchantNumber: string;

  public dtOptions: DataTables.Settings;
  public dtTrigger: Subject<boolean> = new Subject();
  public auditMerchantParamsViewModel: AuditMerchantParamsViewModel[] = [];

  private auditHelperFunctions: AuditHelperFunctions;

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  dtInstance: Promise<DataTables.Api>;

  constructor(private _auditService: AuditService) {
    this.auditHelperFunctions = new AuditHelperFunctions();
  }

  async ngOnInit(): Promise<void> {
    this.dtOptions = {
      order: [''],
      pageLength: 10,
      pagingType: 'full_numbers'
    };
    this.auditMerchantParamsViewModel = await this._auditService.GetMerchantParamsDataDetails(this.merchantNumber);
    this.dtTrigger.next();
  }

  public DownloadCsv(): void {
    this.auditHelperFunctions.DownloadCsv(this.auditMerchantParamsViewModel, 'MerchantParamsData_');
  }

  public print(): void {
    this.auditHelperFunctions.print();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}
